import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-eye-off',
  imports: [],
  templateUrl: './eye-off.html',
  styleUrl: './eye-off.scss',
})
export class EyeOff {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
